import React, { useState, useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";

const Whatsapp = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 8000); // 3 seconds delay

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  const phoneNumber = "9443191026"; // Replace with your actual WhatsApp number
  const message = "Hello, I'm interested in your services!";
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  const buttonStyle = {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#25d366",
    color: "white",
    padding: "15px",
    borderRadius: "50%",
    fontSize: "24px",
    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.2)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "30px",
    height: "30px",
    cursor: "pointer",
    textDecoration: "none",
  };

  return showButton ? (
    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" style={buttonStyle}>
      <FaWhatsapp />
    </a>
  ) : null;
};

export default Whatsapp;
